<template>
    <div class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" :src="backIcon" @click="moving()" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Pegawai</label>
                        <input 
                            class="form-control" 
                            disabled
                            v-model="datas.nama"
                            placeholder="Nama Pegawai"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>NIP</label>
                        <input 
                            class="form-control" 
                            disabled
                            v-model="datas.nik"
                            placeholder="Nomor Induk Pegawai"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Bidang</label>
                        <input 
                            class="form-control" 
                            disabled
                            v-model="datas.bidang"
                            placeholder="Bidang"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Jabatan</label>
                        <input 
                            class="form-control" 
                            disabled
                            v-model="datas.jabatan"
                            placeholder="Jabatan"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Nama PJTK</label>
                        <input 
                            class="form-control" 
                            disabled
                            v-model="datas.organisasiPJTK"
                            placeholder="Nama Kontrak"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Nama Kontrak</label>
                        <input 
                            class="form-control" 
                            disabled
                            v-model="datas.namaKontrak"
                            placeholder="Nama Kontrak"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Nomor Kontrak</label>
                        <input 
                            class="form-control" 
                            disabled
                            v-model="datas.nomorKontrak"
                            placeholder="Nomor Kontrak"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>Tanggal Aktif</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.tanggalAktif.$model"
                            :class="{ 'is-invalid':$v.tanggalAktif.$error, 'is-valid': !$v.tanggalAktif.$invalid }"
                            placeholder="Tanggal Aktif"
                            type="date"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Tanggal Nonaktif</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.tanggalNonaktif.$model"
                            :class="{ 'is-invalid':$v.tanggalNonaktif.$error, 'is-valid': !$v.tanggalNonaktif.$invalid }"
                            placeholder="Tanggal Nonaktif"
                            type="date"
                        />
                    </CCol>
                </CRow>
                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>Harga Satuan (Rp.)</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.hargaSatuan.$model"
                            :class="{ 'is-invalid':$v.hargaSatuan.$error, 'is-valid': !$v.hargaSatuan.$invalid }"
                            placeholder="Harga Satuan"
                            @input="rupiahMode()"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Penempatan Wilayah</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.wilayah.$model"
                            :class="{ 'is-invalid':$v.wilayah.$error, 'is-valid': !$v.wilayah.$invalid }"
                            placeholder="Wilayah"
                            type="text"
                        />
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import {DataApi} from "../../../service/DataApi";
import { validationMixin } from 'vuelidate'
export default {
    props: ['isDetail', 'isData'],
    mixins: [validationMixin],
    validations: {
        hargaSatuan: {
            required,
        },
        wilayah: {
            required,
        },
        tanggalAktif: {
            required,
        },
        tanggalNonaktif: {
            required,
        },
    },
    data() {
        return {
            loading: false,
            details: false,
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            hargaSatuan: '',
            wilayah: '',
            tanggalAktif: '',
            tanggalNonaktif: '',
            datas: []
        }
    },
    methods: {
        moving() {
            this.details = false
            this.$v.$reset()
            this.$emit('goDetail', false)
        },
        
        pharData() {
            let li = this.datas
            this.rupiahModeEdit(li.hargaSatuan)
            this.wilayah = li.wilayah
            this.tanggalAktif = li.tglAktif
            this.tanggalNonaktif = li.tglNonAktif
        },
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.goSave()
                this.loading = true
            }
        },
        goSave() {
            let num = this.hargaSatuan.replace("Rp. ", '')
            let harga = num.replaceAll(".", '')
            let payload = {
                hargaSatuan: harga,
                idPegawaiKontrak: this.datas.idPegawaiKontrak,
                wilayah: this.wilayah,
                tglAktif: this.tanggalAktif,
                tglNonAktif: this.tanggalNonaktif
            }
            DataApi.post("pegawai_kontrak/save", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.details = false
                this.$v.$reset()
                let sendParam = {
                    suc: this.success,
                    resp: this.alertMess
                }
                this.$emit('goUpdate', sendParam)
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        rupiahModeEdit(val) {
            var number_string = val.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            this.hargaSatuan = hasil
        },
        rupiahMode() {
            var number_string = this.hargaSatuan.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            this.hargaSatuan = hasil
        }
    },
    watch: {
        isDetail() {
            if(this.isDetail == true) {
                this.details = true
                this.$emit('goDetail', true)
            }
        },
    },
    mounted() {
        window.scroll({
            top:0,
            left: 0,
            behavior: 'smooth'
        });
        this.datas = this.isData[0]
        this.pharData()
    },
    computed: {
    }
}
</script>
<style scoped>
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
input:disabled {
    opacity: 0.7;
}
</style>